import {Group} from 'src/design/atoms/Group';
import {Image} from 'src/design/atoms/Image';
import {Text} from 'src/design/atoms/Text';
import {IconPhotoOff} from '@tabler/icons-react';
import React, {useState} from 'react';
import {useDownscaledImageSrc} from 'src/shared/hooks/useDownscaledImageSrc';

export interface ImagePreviewProps {
  src: string;
  alt?: string;
}

export const ImagePreview: React.FC<ImagePreviewProps> = ({src, alt}) => {
  const [errored, setErrored] = useState(false);
  const displaySrc = useDownscaledImageSrc(src);

  if (errored) {
    return (
      <Group
        gap="xs"
        c="dimmed"
        p="md"
        style={{
          border: '1px dashed var(--mantine-color-gray-4)',
          borderRadius: 4,
        }}>
        <IconPhotoOff size={20} />
        <Text size="sm">Preview unavailable</Text>
      </Group>
    );
  }

  return (
    <Image
      maw={350}
      mah={350}
      src={displaySrc}
      alt={alt}
      onError={() => setErrored(true)}
    />
  );
};
